import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IGetInvoiceRequest extends IBaseRequest {
    id?: string;
    customId?: string;
}

export class GetInvoiceRequest extends BaseRequest implements IGetInvoiceRequest {
    id?: string;
    customId?: string;
  constructor(server: string, session: string, otherOptions?: any) {
    super(server, session);
    this.id = otherOptions?.id;
    this.customId = otherOptions?.customId;
  }

  public toXml(): string {
    var parameters: string = super.toXml();

    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.customId, 'customId');

    return super.wrapperXml('GetInvoice', parameters);
  }
}
